var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('OareContentView',{attrs:{"title":"Texts","loading":_vm.loading}},[_c('CollectionsList',{attrs:{"collections":_vm.shownCollections}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }